// @ts-nocheck
import SceneLayer from "./layer";

export default class SceneLayerCanvas extends SceneLayer {
	/**
	 * Vytvoreni vrstvy s canvasem.
	 *
	 * @param  {String|Number} [id] Volitelne ID
	 * @param  {String|Number} [layerId] Volitelne layer ID
	 */
	constructor(scene, itemId, id, layerId) {
		super(scene, itemId, id);

		this._layerId = layerId;
		this._contexts = [];
	}

	/**
	 * Informace ohledne entity ve scene.
	 *
	 * @return {Object}
	 */
	// eslint-disable-next-line class-methods-use-this
	get featureInfo() {
		return {
			name: "SceneLayerCanvas",
			type: "layer",
		};
	}

	/**
	 * Souhrn vsech dat, ktere vyuziva visualiser pri vytvoreni.
	 *
	 * @return {Object}
	 */
	getCreateData() {
		const rd = super.getCreateData();

		rd.layerId = this._layerId;
		rd.contexts = this._contexts;

		return rd;
	}

	/**
	 * Ziskani canvas contextu.
	 */
	getContext(...args) {
		this._contexts.push({
			cb: args[0],
			scope: args[1],
		});

		this._onChange(this._scene.featureEvent("layerCanvasGetContext", true, true), args);
	}
}
